<template>
<div class="position-relative mb-3">
<label class="fw-bold">Adress <span class="is-required">*</span></label>
  <input v-if="selectedAddress == ''" type="search" v-model="term" class="form-control" />
  <div v-else class="d-flex justify-content-between"><span>{{ selectedAddress }}</span> <button v-if="currentStep == 0" class="btn pt-0 pe-0" @click="newAddress('')">&#10006;</button></div>
  <div v-if="results.length > 0" class="rounded position-absolute w-100 left-0 right-0 bg-white" style="z-index: 3;">
    <ul class=" list-group">
      <li class=" list-group-item m-0" role="button" v-for="(value, i) in results.slice(0, 10)" @click="newAddress(value)" :key="i">
        {{ value }}
      </li>
    </ul>
  </div>
</div>
  
</template>
<script>
export default {
  props: {"storedAddress": {type: String},
          currentStep: {type: Number},
          selectAddress: {type: Function}},
  data() {
    let selectedAddress = this.storedAddress;

    return {
      term: "",
      selectedAddress,
      results: [],
    };
  },
  methods: {
    fetchAddresses(term) {
      this.results = [];
      fetch("https://apps.gavleenergi.se/powerplant-webservice/servicepoint/geposit/?term=" + term)
        .then((res) => res.json())
        .then((json) =>
          json.map((value) => {
            this.results.push(
              value.street +
                " " +
                value.street_number +
                (typeof value.letter != "undefined" && value.letter != null && value.letter.toString().length > 0 ? value.letter : "") +
                ", " +
                value.postalcode +
                " " +
                value.locality
            );
          })
        );
    },
    newAddress(address) {
      this.selectedAddress = address;
      this.results = [];
      console.log(address);
      this.selectAddress(address);
    },

    clearAddress() {
      this.term = "";
      this.selectedAddress = "";
      
    },
  },

  watch: {
    term() {
      if (this.term.length > 2) {
        this.fetchAddresses(this.term);
      }
      if (this.term.length == 0) {
        this.results = [];
      }
    },
  },
};
</script>
